"use client";

import { createContext, useContext } from "react";
import type { SiteMotion } from "@/lib/motion/site-runtime";

export type MotionBag = {
  motion: SiteMotion;
  epoch: number;
  arm: () => void;
  loaderDone: boolean;
  completeLoader: () => void;
};

export const MotionContext = createContext<MotionBag | null>(null);

export function useMotionBag() {
  const ctx = useContext(MotionContext);
  if (!ctx) throw new Error("useMotionBag requires MotionContext");
  return ctx;
}

export function useMotion() {
  return useMotionBag().motion;
}
